import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    CreatePrintedProductoRfqInput,
    PrintedProductoRfq,
    UpdateProductoRfqInput
} from '@app/core/services/api/API.service';
@Injectable({
    providedIn: 'root'
})
export class PrintedProductoRfqService {
    private amplifyClient = generateClient();

    constructor() {}

    async getPrintedProductoRfq(id: string): Promise<PrintedProductoRfq> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.getPrintedProductoRfq,
                    variables: { id }
                })
            ).data.getPrintedProductoRfq;
            if (data) return data as PrintedProductoRfq;
        } catch (error) {
            console.error('Error finding PrintedProductoRfq:', error);
            return null;
        }
    }

    async listPrintedProductoRfqs(): Promise<PrintedProductoRfq[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.listPrintedProductoRfqs
                })
            ).data.listPrintedProductoRfqs.items;
            if (data) return data as PrintedProductoRfq[];
        } catch (error) {
            console.error('Error finding PrintedProductoRfq:', error);
            return null;
        }
    }

    async listPrintedProductosRfqPrice(
        category_id: string
    ): Promise<PrintedProductoRfq[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.ListPrintedProductosRfqPrice,
                    variables: {
                        category_id
                    }
                })
            ).data.ListPrintedProductosRfqPrice.items;
            if (data) return data as PrintedProductoRfq[];
        } catch (error) {
            console.error('Error finding PrintedProductoRfq:', error);
            return null;
        }
    }

    async createPrintedProductoRfq(
        input: CreatePrintedProductoRfqInput
    ): Promise<PrintedProductoRfq> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.createPrintedProductoRfq,
                    variables: {
                        input
                    }
                })
            ).data.createPrintedProductoRfq;
            if (data) return data as PrintedProductoRfq;
        } catch (error) {
            console.error('Error creating PrintedProductoRfq:', error);
            return null;
        }
    }
    async updatePrintedProductoRfq(
        input: UpdateProductoRfqInput
    ): Promise<PrintedProductoRfq> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: mutations.updatePrintedProductoRfq,
                    variables: {
                        input
                    }
                })
            ).data.updatePrintedProductoRfq;
            if (data) return data as PrintedProductoRfq;
        } catch (error) {
            console.error('Error creating PrintedProductoRfq:', error);
            return null;
        }
    }
}
